export const initialState = {
  showAccepted: false,
  showCancelled: false,
  showPatientCancelled: false,
  showDeclined: false,
  showPending: false,
  showCompleted: false,
  query: {},
  referral: {},
  refreshToken: 0,
  referralsList: [],
  totalSize: 0,
  isLoading: false,
  hasMore: true,
  referralsSearch: {
    filters: [],
    sorts: [],
    pageNumber: 1,
    pageSize: 20
  }
};

export const actions = {
  TOGGLE_ACCEPTED: 'TOGGLE_ACCEPTED',
  TOGGLE_PENDING: 'TOGGLE_PENDING',
  SET_REFERRAL: 'SET_REFERRAL',
  TOGGLE_CANCELLED: 'TOGGLE_CANCELLED',
  TOGGLE_PATIENT_CANCELLED: 'TOGGLE_PATIENT_CANCELLED',
  TOGGLE_DECLINED: 'TOGGLE_DECLINED',
  TOGGLE_COMPLETED: 'TOGGLE_COMPLETED',
  SET_QUERY: 'SET_QUERY',
  SET_REFRESH_TOKEN: 'SET_REFRESH_TOKEN',
  SET_REFERRALS_LIST: 'SET_REFERRALS_LIST',
  SET_TOTAL_SIZE: 'SET_TOTAL_SIZE',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_HAS_MORE: 'SET_HAS_MORE',
  SET_REFERRALS_SEARCH: 'SET_REFERRALS_SEARCH'
};
